var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useEffect } from 'react';
import { BadRequestError } from '@lucidlink/sdk/fetcher';
import { getRootLogger } from '@lucidlink/tscore';
import { translate, useToastService } from '@lucidlink/uicore';
export const useHandleSsoStateError = ({ handleGeneralLoginError, loginEmail, resetLoginFlow, userSsoStateError, }) => {
    _react_refresh_temp_1();
    const { addToast } = useToastService();
    useEffect(() => {
        if (!userSsoStateError) {
            return;
        }
        getRootLogger().error({ err: userSsoStateError, email: loginEmail }, 'Sso state check failed');
        if (userSsoStateError instanceof BadRequestError) {
            addToast({
                'data-testid': 'sso-login-fail',
                content: {
                    label: translate('Attempting to log in using different emails.'),
                    message: translate('Please try again, using the same email during authentication.'),
                },
                kind: 'negative',
            });
            resetLoginFlow();
        }
        else {
            handleGeneralLoginError();
        }
    }, [
        addToast,
        handleGeneralLoginError,
        loginEmail,
        resetLoginFlow,
        userSsoStateError,
    ]);
};
_react_refresh_temp_1(useHandleSsoStateError, "T8FCBKd4eJZq+H9HT4Ygn85woho=", false, () => [useToastService]);
